module.exports = __webpack_public_path__ + "img/seminar (21).06556120.jpg";